import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { FadeInSection } from '@/components/base/FadeInSection';
import HeroSection from './components/HeroSection';
import IntroductionSection from './components/IntroductionSection';
import ElfCharactersSection from './components/ElfCharactersSection';
import ChaptersSection from './components/ChaptersSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "name": "好色精灵探访记",
      "url": "https://haosejingling.com/",
      "description": "好色精灵探访记是一部充满奇幻色彩与创意的互动体验故事",
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "availableLanguage": ["Chinese"]
      }
    },
    {
      "@type": "WebSite",
      "name": "好色精灵探访记",
      "url": "https://haosejingling.com/",
      "description": "奇幻色彩冒险互动体验故事",
      "inLanguage": "zh-CN"
    },
    {
      "@type": "WebPage",
      "name": "好色精灵探访记 - 首页",
      "url": "https://haosejingling.com/",
      "description": "好色精灵探访记奇幻色彩冒险首页",
      "inLanguage": "zh-CN",
      "isPartOf": { "@id": "https://haosejingling.com/#website" }
    },
    {
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "好色精灵探访记是什么类型的作品？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "好色精灵探访记是一部奇幻色彩冒险互动体验故事，通过丰富多彩的精灵角色和引人入胜的冒险篇章，带领读者进入一个充满色彩魔法与想象力的世界。"
          }
        },
        {
          "@type": "Question",
          "name": "好色精灵探访记适合什么年龄段的读者？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "好色精灵探访记适合全年龄段读者。故事语言生动有趣，色彩主题丰富多元，既能吸引小朋友的注意力，也能让成年读者在奇幻冒险中找到共鸣与启发。"
          }
        },
        {
          "@type": "Question",
          "name": "如何获取最新的精灵冒险篇章？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "你可以通过浏览我们的官方网站获取最新的冒险篇章更新。我们定期发布新的精灵故事和色彩冒险内容。"
          }
        },
        {
          "@type": "Question",
          "name": "每个精灵的颜色主题有什么特殊含义吗？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "每一位精灵的颜色主题都经过精心设计，代表着不同的情感和品质。例如，炽色精灵的红色象征勇气与热情，森林精灵的绿色代表生机与和谐。"
          }
        },
        {
          "@type": "Question",
          "name": "好色精灵探访记有实体出版物吗？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "目前好色精灵探访记主要以数字内容形式呈现。我们正在积极筹备相关的实体出版物和周边产品，敬请期待！"
          }
        },
        {
          "@type": "Question",
          "name": "我可以参与好色精灵探访记的创作吗？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "我们非常欢迎热爱色彩和奇幻故事的创作者加入！如果你有关于精灵角色或色彩冒险的创意想法，可以通过联系我们页面提交你的创意。"
          }
        }
      ]
    }
  ]
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <ScrollToTop />
      <Navbar transparent={true} />
      <main>
        <HeroSection />
        <FadeInSection><IntroductionSection /></FadeInSection>
        <FadeInSection delay={100}><ElfCharactersSection /></FadeInSection>
        <FadeInSection delay={100}><ChaptersSection /></FadeInSection>
        <FadeInSection delay={100}><FAQSection /></FadeInSection>
        <FadeInSection delay={200}><CTASection /></FadeInSection>
      </main>
      <Footer />
    </>
  );
}